import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { IFundHeaderService } from "services/FundHeaderService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

const initialState = {
  FundHeaderSelectModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const fundHeaderSelectSlice = createSlice({
  name: "fundHeaderSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFundHeaderSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getFundHeaderSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getFundHeaderSelectModels.fulfilled, (state, action) => {
        state.FundHeaderSelectModels = action.payload;
        state.LastUpdateTime = new Date();
        state.Loading = false;
      });
  },
});

export const getFundHeaderSelectModels = createAsyncThunk("FundHeader/GetSelectModels", async () => {
  const fundHeaderService = container.get<IFundHeaderService>(SERVICE_TYPES.FundHeaderService);
  return await fundHeaderService.getSelectModels();
});

export const selectFundHeaderSelectModels = (state: RootState) => {
  return state.fundHeaderSelect.FundHeaderSelectModels;
};

export const selectLoading = (state: RootState) => {
  return state.fundHeaderSelect.Loading;
};

export default fundHeaderSelectSlice.reducer;
